import axios from 'axios'
import APIConfig from '@/assets/js/data/remote/APIConfig.js'
import config from '@/assets/js/config.js'

export default class ProductInfoService {
  constructor () {
    this.apis = {
      getAll: () => axios.get(APIConfig.BPIURL + '/productInfo'),
      add: (payload) => axios.post(APIConfig.BPIURL + '/productInfo', payload),
      edit: (id, payload) => axios.put(APIConfig.BPIURL + `/productInfo/${id}`, payload),
      delete: (id) => axios.delete(APIConfig.BPIURL + `/productInfo/${id}`),
      inActivate: (id) => axios.post(APIConfig.BPIURL + `/productInfo/${id}/inactivate`),
      updateInStock: (id, payload) => axios.put(APIConfig.BPIURL + `/productInfo/${id}/in-stock`, payload),
      getInStockLog: (id) => axios.get(APIConfig.BPIURL + `/productInfoInStockLogOf/${id}`)
    }

    // fake data
    if (config.useFakeData) {
      this.apis = {
        getAll: () => new Promise((resolve, reject) => {
          var res = {
            data: {
              status: 'ok',
              result: []
            }
          }
          resolve(res)
        })
      }
    }
  }

  getAll (vm) {
    vm.isLoading = true
    return this.apis.getAll()
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  add (vm, payload) {
    vm.isLoading = true
    return this.apis.add(payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  edit (vm, payload) {
    vm.isLoading = true
    return this.apis.edit(payload.ID, payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  delete (vm, id) {
    vm.isLoading = true
    return this.apis.delete(id)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  inActivate (vm, id) {
    vm.isLoading = true
    return this.apis.inActivate(id)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  updateInStock (vm, id, payload) {
    vm.isLoading = true
    return this.apis.updateInStock(id, payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  getInStockLog (vm, id) {
    vm.isLoading = true
    return this.apis.getInStockLog(id)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }
}
